
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class HexagonGridEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config } = pc;
        const spacing = (200 + layerIndex * 100) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing);

        const r = spacing * 0.6 * (config.parallaxScale || 1.0);
        const h = r * Math.sqrt(3);
        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 2 * (config.parallaxScale || 1.0);

        const draw = () => {
            for (let x = x1; x <= x2; x += r * 1.5) {
                for (let y = y1; y <= y2; y += h) {
                    const ox = (Math.floor(x / (r * 1.5)) % 2 === 0) ? 0 : h / 2;
                    ctx.beginPath();
                    for (let i = 0; i < 6; i++) {
                        const a = (i / 6) * Math.PI * 2;
                        const px = x + Math.cos(a) * r;
                        const py = y + Math.sin(a) * r + ox;
                        if (i === 0) ctx.moveTo(px, py);
                        else ctx.lineTo(px, py);
                    }
                    ctx.closePath();
                    ctx.stroke();
                }
            }
        };
        draw();
        this.applyGlow(pc, draw);
    }
}
